import React, { Component } from 'react';
import styles from './severity-codetable-list-component.scss';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { SpinLoader } from 'app/components';
import { SeverityCodetableListItems } from './severity-codetable-list-items';
import { CustomCodetableListComponentProps } from 'app/area/codetable/list/list-renderer/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';

export class SeverityCodetableListComponent extends Component<CustomCodetableListComponentProps> {

  public render() {
    const { itemAccess, fetchingItemAccess, translation, isHierarchy, isHierarchyMode,
      shouldRenderSpinLoader, screenPayload, rootBranch, breadcrumbs, metadata,
      codetableId, codeId, codeListBranch, codeListBranchState,
      loadFromParent, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess } = this.props;

    const shouldRenderList = !!codeListBranch && codeListBranch.length > 0 && rootBranch
      && rootBranch.numberOfResults > 0;

    return <SearchFilters {...this.props}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <div className={styles.numberOfResults}>
            <NumberOfResults
              rootBranch={rootBranch}
              translation={translation} />
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>

              <div className={styles.listItems}>
                <SeverityCodetableListItems
                  screenPayload={screenPayload}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={this.props.codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory}
                  metadata={metadata} />
              </div>
            </div>
          }
        </div>
      </div>
    </SearchFilters>;
  }
}
